import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import Input from '../../components/UI/Input/index';
import Modal from '../../components/UI/Modal';
import { updateOrderTotalAmount } from './../../actions/order.action';

const RenderSettingOrderNumberModal = ({
    orderDetails,
    onHide,
    show,
}) => {
    const [orderNumberAdditional, setOrderNumberAdditional] = useState(
        orderDetails === null ? "" : orderDetails.orderNumberAdditional
    )
    const [orderNumber, setOrderNumber] = useState(
        orderDetails === null ? "" : orderDetails.orderNumber
    )
    useEffect(() => {
        if (show) {
            setOrderNumberAdditional(orderDetails.orderNumberAdditional)
            setOrderNumber(orderDetails.orderNumber)
        }
    }, [show])

    const dispatch = useDispatch()
    console.log("orderDetails", orderDetails)


    const handleOrderNumberAdditional = () => {
        if (!orderDetails || !orderDetails._id) {
            console.warn("❌ orderDetails или orderDetails._id отсутствует!"); // добавь лог
            return; // не отправляем запрос вообще
        }

        const payload = {
            typeSet: "orderNumberAdditional",
            orderNumber,
            orderNumberAdditional,
            orderId: "685a7996c37d8fdbc0d8be7d"
        };
        dispatch(updateOrderTotalAmount(payload));
    };
    return (
        <Modal
            show={show}
            handleClose={onHide}
            modalTitle={`Настройка номера заказа`}
            onSubmit={handleOrderNumberAdditional}
        >

            <Input
                label="Основной номер"
                value={orderNumber}
                placeholder={"Основной"}
                onChange={(e) => setOrderNumber(e.target.value)}
            />
            <Input
                label="Доп-номер(текст)"
                value={orderNumberAdditional}
                placeholder={"Дополнительный номер"}
                onChange={(e) => setOrderNumberAdditional(e.target.value)}
            />
        </Modal>
    )
}

export default RenderSettingOrderNumberModal